module.exports = __webpack_public_path__ + "static/InterFace-Italic-5240ff635dea65c4e98c1266d5f85279.woff";